import React from 'react';

function ImageSkeleton({ className = 'h-full w-full' }) {
  return <div className={`skeleton-shimmer ${className}`} aria-hidden />;
}

export default ImageSkeleton;
